module.exports = __webpack_public_path__ + "img/banner-bg@2x.120de503.png";